import React from "react";
import BaseConverters from "../components/BaseConverters";

export default function Favorites() {
  return <BaseConverters mode="favorites" />;
}
